import { Form, Input, Switch } from 'antd';
import React, { useState } from 'react';
import FormPage from '../../../../../components/pages/FormPage';

const DefModel = {
    name: '',
    address: '',
    email: '',
    is_production: true
}

export default () => {
    const [model, setModel] = useState(DefModel);
    return (
        <FormPage
            url={'api/v1/pjt'}
            formValid={false}
            model={model}
            setModel={setModel}
            wrapperCol={{ span: 8 }}
            labelCol={{ span: 3 }}
            title={"PJT"}
            emptyModel={DefModel}
            callbackPath={"/master/pjt"}
            onSaveEvent={(model) => {
                const { name, ...das } = model;
                return {
                    name: name?.toUpperCase(),
                    ...das
                }
            }}
        >
            <Form.Item name={'name'} label="Name" rules={[{ required: true }]} >
                <Input style={{ textTransform: 'uppercase' }} autoComplete="off" />
            </Form.Item>
            <Form.Item name={'address'} label="Address" >
                <Input autoComplete="off" onInput={e => e.target.value} />
            </Form.Item>
            <Form.Item name={'email'} label="Email" >
                <Input autoComplete="off" onInput={e => e.target.value} />
            </Form.Item>
            <Form.Item
                name={'is_production'}
                label="Production"
                valuePropName="checked"
            >
                <Switch checkedChildren="True" unCheckedChildren="False" />
            </Form.Item>
        </FormPage>
    )
}
